import { Suspense } from 'react'
import { createBrowserRouter, Navigate } from 'react-router'
import RootLayout from './app/layout'
import GlobalError from './app/global-error'
import UnauthenticatedLayout from './app/(unauthenticated)/layout'
import LoginPage from './app/(unauthenticated)/login/page'
import CreateAccountPage from './app/(unauthenticated)/create-account/page'
import ForgotPasswordPage from './app/(unauthenticated)/forgot-password/page'
import ResetPasswordPage from './app/(unauthenticated)/reset-password/page'
import NoOrganizationLayout from './app/(dashboard)/(no-organization)/layout'
import NoOrganizationHomePage from './app/(dashboard)/(no-organization)/(home)/page'
import SupportPage from './app/(dashboard)/support/page'
import SettingsLayout from './app/(dashboard)/settings/layout'
import OrganizationLayout from './app/(dashboard)/[organization]/layout'
import OrganizationHomePage from './app/(dashboard)/[organization]/(home)/page'
import PartnersPage from './app/(dashboard)/[organization]/partners/page'
import PartnerPage from './app/(dashboard)/[organization]/partners/[partner]/page'
import CustomersPage from './app/(dashboard)/[organization]/customers/page'
import CustomerPage from './app/(dashboard)/[organization]/customers/[customer]/page'
import KeycardsPage from './app/(dashboard)/[organization]/keycards/page'
import PersonalKeycardsPage from './app/(dashboard)/[organization]/personal-keycards/page'
import ChargersPage from './app/(dashboard)/[organization]/chargers/page'
import StickersPage from './app/(dashboard)/[organization]/stickers/page'
import MembersPage from './app/(dashboard)/[organization]/team/members/page'
import InvitationsPage from './app/(dashboard)/[organization]/team/invitations/page'
import AccountPage from './app/(dashboard)/settings/account/page'
import AppearancePage from './app/(dashboard)/settings/appearance/page'
import OrganizationsPage from './app/(dashboard)/settings/organizations/page'
import LeaveOrganizationModal from './app/(dashboard)/settings/organizations/@modal/[organization]/leave/page'
import PartnersLoading from './app/(dashboard)/[organization]/partners/loading'
import PartnersError from './app/(dashboard)/[organization]/partners/error'
import NewPartnerModal from './app/(dashboard)/[organization]/partners/@modal/new/page'
import PartnerLoading from './app/(dashboard)/[organization]/partners/[partner]/loading'
import PartnerError from './app/(dashboard)/[organization]/partners/[partner]/error'
import CustomersLoading from './app/(dashboard)/[organization]/customers/loading'
import CustomersError from './app/(dashboard)/[organization]/customers/error'
import NewCustomerModal from './app/(dashboard)/[organization]/customers/@modal/new/page'
import CustomerLoading from './app/(dashboard)/[organization]/customers/[customer]/loading'
import CustomerError from './app/(dashboard)/[organization]/customers/[customer]/error'
import KeycardsLoading from './app/(dashboard)/[organization]/keycards/loading'
import KeycardsError from './app/(dashboard)/[organization]/keycards/error'
import PersonalKeycardsLoading from './app/(dashboard)/[organization]/personal-keycards/loading'
import PersonalKeycardsError from './app/(dashboard)/[organization]/personal-keycards/error'
import NewChargerModal from './app/(dashboard)/[organization]/chargers/@modal/new/page'
import ChargersLoading from './app/(dashboard)/[organization]/chargers/loading'
import ChargersError from './app/(dashboard)/[organization]/chargers/error'
import NewStickerModal from './app/(dashboard)/[organization]/stickers/@modal/new/page'
import StickersLoading from './app/(dashboard)/[organization]/stickers/loading'
import StickersError from './app/(dashboard)/[organization]/stickers/error'
import TeamLayout from './app/(dashboard)/[organization]/team/layout'
import MembersLoading from './app/(dashboard)/[organization]/team/members/loading'
import MembersError from './app/(dashboard)/[organization]/team/members/error'
import RemoveMemberModal from './app/(dashboard)/[organization]/team/members/@modal/[membership]/remove/page'
import ChangeMemberAccessModal from './app/(dashboard)/[organization]/team/members/@modal/[membership]/change-access/page'
import InvitationsLoading from './app/(dashboard)/[organization]/team/invitations/loading'
import InvitationsError from './app/(dashboard)/[organization]/team/invitations/error'
import NewInvitationModal from './app/(dashboard)/[organization]/team/invitations/@modal/new/page'
import CancelInvitationModal from './app/(dashboard)/[organization]/team/invitations/@modal/[invitation]/cancel/page'
import AccountLoading from './app/(dashboard)/settings/account/loading'
import AccountError from './app/(dashboard)/settings/account/error'
import AppearanceError from './app/(dashboard)/settings/appearance/error'
import AppearanceLoading from './app/(dashboard)/settings/appearance/loading'
import OrganizationsLoading from './app/(dashboard)/settings/organizations/loading'
import OrganizationsError from './app/(dashboard)/settings/organizations/error'
import VerifyEmailPage from './app/(unauthenticated)/verify-email/page'
import InvitationPage from './app/(unauthenticated)/invitations/[invitation]/page'
import InvitationInvalidPage from './app/(unauthenticated)/invitations/invalid/page'
import InvitationRejectedPage from './app/(unauthenticated)/invitations/rejected/page'
import UnauthenticatedError from './app/(unauthenticated)/error'
import NoOrganizationError from './app/(dashboard)/(no-organization)/error'
import OrganizationError from './app/(dashboard)/[organization]/error'
import NewMemberModal from './app/(dashboard)/[organization]/customers/[customer]/@modal/members/new/page'
import InviteMemberModal from './app/(dashboard)/[organization]/customers/[customer]/@modal/members/invite/page'
import RemoveCustomerMemberModal from './app/(dashboard)/[organization]/customers/[customer]/@modal/members/[member]/remove/page'
import ChargerLoading from './app/(dashboard)/[organization]/chargers/[charger]/loading'
import ChargerPage from './app/(dashboard)/[organization]/chargers/[charger]/page'
import ChargerError from './app/(dashboard)/[organization]/chargers/[charger]/error'
import KeycardLoading from './app/(dashboard)/[organization]/keycards/[keycard]/loading'
import KeycardPage from './app/(dashboard)/[organization]/keycards/[keycard]/page'
import KeycardError from './app/(dashboard)/[organization]/keycards/[keycard]/error'
import NewPersonalKeycardModal from './app/(dashboard)/[organization]/personal-keycards/@modal/new/page'
import PersonalKeycardLoading from './app/(dashboard)/[organization]/personal-keycards/[personal-keycard]/loading'
import PersonalKeycardPage from './app/(dashboard)/[organization]/personal-keycards/[personal-keycard]/page'
import PersonalKeycardError from './app/(dashboard)/[organization]/personal-keycards/[personal-keycard]/error'
import StickerLoading from './app/(dashboard)/[organization]/stickers/[sticker]/loading'
import StickerPage from './app/(dashboard)/[organization]/stickers/[sticker]/page'
import StickerError from './app/(dashboard)/[organization]/stickers/[sticker]/error'
import NewKeycardModal from './app/(dashboard)/[organization]/keycards/@modal/new/page'


export const router = createBrowserRouter([
  {
    path: '/',
    element: <Suspense fallback={null}><RootLayout /></Suspense>,
    errorElement: <GlobalError />,
    children: [
      {
        element: <UnauthenticatedLayout />,
        children: [
          {
            errorElement: <UnauthenticatedError />,
            children: [
              {
                path: 'login',
                element: <LoginPage />
              },
              {
                path: 'create-account',
                element: <CreateAccountPage />
              },
              {
                path: 'forgot-password',
                element: <ForgotPasswordPage />
              },
              {
                path: 'reset-password',
                element: <ResetPasswordPage />
              },
              {
                path: 'invitations/invalid',
                element: <InvitationInvalidPage />
              },
              {
                path: 'invitations/rejected',
                element: <InvitationRejectedPage />
              },
              {
                path: 'invitations/:invitation',
                element: <InvitationPage />
              },
              {
                path: 'verify-email',
                element: <VerifyEmailPage />
              }
            ]
          }
        ]
      },
      {
        element: <NoOrganizationLayout />,
        children: [
          {
            errorElement: <NoOrganizationError />,
            children: [
              {
                index: true,
                element: <NoOrganizationHomePage />
              },
              {
                path: 'support',
                element: <SupportPage />
              },
              {
                element: <SettingsLayout />,
                children: [
                  {
                    path: 'settings/account',
                    element: <Suspense fallback={<AccountLoading />}><AccountPage /></Suspense>,
                    errorElement: <AccountError />
                  },
                  {
                    path: 'settings/appearance',
                    element: <Suspense fallback={<AppearanceLoading />}><AppearancePage /></Suspense>,
                    errorElement: <AppearanceError />
                  },
                  {
                    path: 'settings/organizations',
                    element: <Suspense fallback={<OrganizationsLoading />}><OrganizationsPage /></Suspense>,
                    errorElement: <OrganizationsError />,
                    children: [
                      {
                        path: ':organization/leave',
                        element: <LeaveOrganizationModal />
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        element: <OrganizationLayout />,
        children: [
          {
            path: ':organization',
            errorElement: <OrganizationError />,
            children: [
              {
                index: true,
                element: <OrganizationHomePage />
              },
              {
                path: 'partners',
                children: [
                  {
                    path: '',
                    element: <Suspense fallback={<PartnersLoading />}><PartnersPage /></Suspense>,
                    errorElement: <PartnersError />,
                    children: [
                      {
                        path: 'new',
                        element: <NewPartnerModal />
                      }
                    ]
                  },
                  {
                    path: ':partner',
                    element: <Suspense fallback={<PartnerLoading />}><PartnerPage /></Suspense>,
                    errorElement: <PartnerError />
                  }
                ]
              },
              {
                path: 'customers',
                children: [
                  {
                    path: '',
                    element: <Suspense fallback={<CustomersLoading />}><CustomersPage /></Suspense>,
                    errorElement: <CustomersError />,
                    children: [
                      {
                        path: 'new',
                        element: <NewCustomerModal />
                      }
                    ]
                  },
                  {
                    path: ':customer',
                    element: <Suspense fallback={<CustomerLoading />}><CustomerPage /></Suspense>,
                    errorElement: <CustomerError />,
                    children: [
                      {
                        path: 'members/new',
                        element: <NewMemberModal />
                      },
                      {
                        path: 'members/invite',
                        element: <InviteMemberModal />
                      },
                      {
                        path: 'members/:member/remove',
                        element: <RemoveCustomerMemberModal />
                      }
                    ]
                  }
                ]
              },
              {
                path: 'keycards',
                children: [
                  {
                    path: '',
                    element: <Suspense fallback={<KeycardsLoading />}><KeycardsPage /></Suspense>,
                    errorElement: <KeycardsError />,
                    children: [
                      {
                        path: 'new',
                        element: <NewKeycardModal />
                      }
                    ]
                  },
                  {
                    path: ':keycard',
                    element: <Suspense fallback={<KeycardLoading />}><KeycardPage /></Suspense>,
                    errorElement: <KeycardError />
                  }
                ]
              },
              {
                path: 'personal-keycards',
                children: [
                  {
                    path: '',
                    element: <Suspense fallback={<PersonalKeycardsLoading />}><PersonalKeycardsPage /></Suspense>,
                    errorElement: <PersonalKeycardsError />,
                    children: [
                      {
                        path: 'new',
                        element: <NewPersonalKeycardModal />
                      }
                    ]
                  },
                  {
                    path: ':personalKeycard',
                    element: <Suspense fallback={<PersonalKeycardLoading />}><PersonalKeycardPage /></Suspense>,
                    errorElement: <PersonalKeycardError />
                  }
                ]
              },
              {
                path: 'chargers',
                children: [
                  {
                    path: '',
                    element: <Suspense fallback={<ChargersLoading />}><ChargersPage /></Suspense>,
                    errorElement: <ChargersError />,
                    children: [
                      {
                        path: 'new',
                        element: <NewChargerModal />
                      }
                    ]
                  },
                  {
                    path: ':charger',
                    element: <Suspense fallback={<ChargerLoading />}><ChargerPage /></Suspense>,
                    errorElement: <ChargerError />
                  }
                ]
              },
              {
                path: 'stickers',
                children: [
                  {
                    path: '',
                    element: <Suspense fallback={<StickersLoading />}><StickersPage /></Suspense>,
                    errorElement: <StickersError />,
                    children: [
                      {
                        path: 'new',
                        element: <NewStickerModal />
                      }
                    ]
                  },
                  {
                    path: ':sticker',
                    element: <Suspense fallback={<StickerLoading />}><StickerPage /></Suspense>,
                    errorElement: <StickerError />
                  }
                ]
              },
              {
                element: <TeamLayout />,
                children: [
                  {
                    path: 'team/members',
                    element: <Suspense fallback={<MembersLoading />}><MembersPage /></Suspense>,
                    errorElement: <MembersError />,
                    children: [
                      {
                        path: ':membership/remove',
                        element: <RemoveMemberModal />
                      },
                      {
                        path: ':membership/change-access',
                        element: <ChangeMemberAccessModal />
                      }
                    ]
                  },
                  {
                    path: 'team/invitations',
                    element: <Suspense fallback={<InvitationsLoading />}><InvitationsPage /></Suspense>,
                    errorElement: <InvitationsError />,
                    children: [
                      {
                        path: 'new',
                        element: <NewInvitationModal />
                      },
                      {
                        path: ':invitation/cancel',
                        element: <CancelInvitationModal />
                      }
                    ]
                  }
                ]
              },
              {
                path: 'support',
                element: <SupportPage />
              },
              {
                element: <SettingsLayout />,
                children: [
                  {
                    path: 'settings/account',
                    element: <Suspense fallback={<AccountLoading />}><AccountPage /></Suspense>,
                    errorElement: <AccountError />
                  },
                  {
                    path: 'settings/appearance',
                    element: <Suspense fallback={<AppearanceLoading />}><AppearancePage /></Suspense>,
                    errorElement: <AppearanceError />
                  },
                  {
                    path: 'settings/organizations',
                    element: <Suspense fallback={<OrganizationsLoading />}><OrganizationsPage /></Suspense>,
                    errorElement: <OrganizationsError />,
                    children: [
                      {
                        path: ':organization/leave',
                        element: <LeaveOrganizationModal />
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: '*',
        element: <Navigate to="/" replace />
      }
    ]
  }
])
